import {
  doHouseVote,
  fetchCategories,
  fetchCategoryImages,
  fetchHouseImages,
  fetchHouses,
  fetchTownImages,
  fetchTownList,
  uploadTownImages,
} from "@/services/map-town";
import { createSlice, createAsyncThunk, current } from "@reduxjs/toolkit";

let initState = {
  tooltipData: {
    townName: "",
    likes: "",
    insert: "",
  },
  currentModal: "",
  currentStep: "",
  modalVisible: false,
  isUnsureVisible: false,
  isFinalStep: false,
  isUploadedImage: false,
  isExitConfirmVisible: false,
  imgId: 0,
  townList: [],
  mainCategories: [],
  formData: [],
  townSliderImages: [],
  uploadedImagesStep1: [],
  latestHouseImages: [],
  houses: [],
  isMouseOver: false,
  didVote: false,
  isSubmitted: false,
};

export const fetchLatestHouseImagesFilter = createAsyncThunk(
  "house/fetchLatestHouseImagesFilter",
  async (cateID, thunkAPI) => {
    return await fetchCategoryImages(cateID);
  }
);

export const fetchLatestHouseImages = createAsyncThunk(
  "house/fetchLatestHouseImages",
  async (thunkAPI) => {
    return await fetchHouseImages();
  }
);

export const fetchCategoryImagesAsync = createAsyncThunk(
  "house/fetchCategoryImagesAsync",
  async (cateID, thunkAPI) => {
    return await fetchCategoryImages(cateID);
  }
);

// export const fetchImageByIdAsync = createAsyncThunk(
//   "house/fetchImageByIdAsync",
//   async (imgID, thunkAPI) => {
//     return await fetchImageById(imgID);
//   }
// );

export const fetchCategoriesAsync = createAsyncThunk(
  "house/fetchCategoriesAsync",
  async (thunkAPI) => {
    return await fetchCategories();
  }
);

export const fetchTownListAsync = createAsyncThunk(
  "house/fetchTownListAsync",
  async (thunkAPI) => {
    return await fetchTownList();
  }
);

export const fetchHousesAsync = createAsyncThunk(
  "house/fetchHousesAsync",
  async (thunkAPI) => {
    return await fetchHouses();
  }
);

export const doHouseVoteAsync = createAsyncThunk(
  "house/doHouseVote",
  async (imageID, thunkAPI) => {
    const VOTED_IMAGES = "votedImages";
    let VOTED_IMAGESStorage = JSON.parse(localStorage.getItem(VOTED_IMAGES));

    if (VOTED_IMAGESStorage === null) {
      const responseVote = await doHouseVote(imageID);
      localStorage.setItem(VOTED_IMAGES, JSON.stringify([responseVote.item]));
      return responseVote;
    }

    const isImageVoted = VOTED_IMAGESStorage.find((item) => item.id == imageID);

    if (isImageVoted) return { item: isImageVoted };

    const responseVote = await doHouseVote(imageID);
    localStorage.setItem(
      VOTED_IMAGES,
      JSON.stringify([...VOTED_IMAGESStorage, responseVote.item])
    );

    return responseVote;
  }
);

export const fetchTownImagesAsync = createAsyncThunk(
  "house/fetchTownImagesAsync",
  async (townID, thunkAPI) => {
    const responseTownImages = await fetchTownImages(townID);
    return responseTownImages;
  }
);

export const uploadTownImagesAsync = createAsyncThunk(
  "house/uploadTownImages",
  async (data, thunkAPI) => {
    const responseUploadTownImages = await uploadTownImages(data);
    return responseUploadTownImages;
  }
);

const setImgIndex = (imgId, imgList) => {
  var itemIndex = imgList.findIndex((item) => item.id == imgId);
  imgList.splice(
    0, // new index,
    0, // no removal
    imgList.splice(itemIndex, 1)[0] // detach the item and return it
  );
  return imgList;
};

const GlobalSlice = createSlice({
  name: "globalSlice",
  initialState: initState,
  reducers: {
    toggleSubmitted: (state, action) => {
      state.isSubmitted = !state.isSubmitted;
    },
    setDidVote: (state, action) => {
      state.didVote = true;
    },
    setImgId: (state, action) => {
      state.imgId = action.payload;
    },
    toggleUnsureVisible: (state, action) => {
      state.isUnsureVisible = !state.isUnsureVisible;
    },
    setFormData: (state, action) => {
      state.formData = action.payload;
    },
    setCurrentModal: (state, action) => {
      if (action.payload === "townSlider") state.didVote = false;
      state.currentModal = action.payload;
    },
    setIsUploadedImage: (state, action) => {
      state.isUploadedImage = true;
    },
    setIsFinalStep: (state, action) => {
      state.isFinalStep = true;
    },
    setTooltipData: (state, action) => {
      state.tooltipData = state.townList.find(
        (town) => town.id == action.payload
      );
    },
    setIsMouseOver: (state, action) => {
      state.isMouseOver = true;
    },
    toggleModal: (state, action) => {
      state.modalVisible = !state.modalVisible;
    },
    openModal: (state, action) => {
      state.modalVisible = true;
    },
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
    },
    toggleModalConfirm: (state, action) => {
      state.isExitConfirmVisible = !state.isExitConfirmVisible;
    },
  },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [fetchLatestHouseImages.fulfilled]: (state, action) => {
      state.latestHouseImages = [...action.payload].slice(0, 7);
    },
    [fetchCategoriesAsync.fulfilled]: (state, action) => {
      state.mainCategories = action.payload;
    },
    [fetchTownListAsync.fulfilled]: (state, action) => {
      state.townList = action.payload;
    },
    [fetchHousesAsync.fulfilled]: (state, action) => {
      state.houses = action.payload;
    },
    [fetchLatestHouseImagesFilter.fulfilled]: (state, action) => {
      state.latestHouseImages = [...action.payload].slice(0, 7);
    },
    [fetchCategoryImagesAsync.fulfilled]: (state, action) => {
      if (action.payload.length == 0) {
        state.townSliderImages = [];
        return;
      }
      let imgs = action.payload;
      if (typeof state.imgId != "undefined") {
        imgs = setImgIndex(state.imgId, action.payload);
      }
      state.townSliderImages = imgs;
    },
    [uploadTownImagesAsync.fulfilled]: (state, action) => {
      state.uploadedImagesStep1 = action.payload;
    },
    [fetchTownImagesAsync.fulfilled]: (state, action) => {
      if (action.payload.length == 0) {
        state.townSliderImages = [];
        return;
      }
      let imgs = action.payload;
      if (typeof state.imgId != "undefined") {
        imgs = setImgIndex(state.imgId, action.payload);
      }
      state.townSliderImages = imgs;
    },
    [doHouseVoteAsync.fulfilled]: (state, action) => {
      state.didVote = true;
      state.townSliderImages = [...state.townSliderImages].map((item) =>
        item.id == action.payload.item.id
          ? { ...item, total_voted: action.payload.item.total_voted }
          : item
      );
    },
    // [fetchImageByIdAsync.fulfilled]: async (state, action) => {
    //   const imgObj = action.payload;
    //   if ( typeof imgObj.house.town_id != 'undefined') {
    //     state.townSliderImages = await fetchTownImages(imgObj.house.town_id); ////????
    //   }
    // },
  },
});

export const {
  toggleSubmitted,
  toggleModal,
  setDidVote,
  openModal,
  setTooltipData,
  setCurrentStep,
  toggleModalConfirm,
  setIsFinalStep,
  setCurrentModal,
  setTownList,
  setIsUploadedImage,
  setMainCategories,
  setFormData,
  toggleUnsureVisible,
  setImgId,
  setIsMouseOver,
} = GlobalSlice.actions;

export default GlobalSlice.reducer;
